<template>
    <div>
        <ul class="nav nav-tabs tab-deactive" style="border-bottom-color: transparent !important;">
            <li v-for="tag in tags" class="nav-item" style="cursor: pointer;">
                <div @click="routeByTag(tag)" :class="{'nav-link': true, 'active': tag.key === route.name}">{{ $t(tag.key) }}</div>
            </li>
        </ul>
        <router-view/>
    </div>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'analysis',
    data() {
        return {
            tags: [{key: 'general-analysis'}, {key: 'scope-1'}, {key: 'scope-2'}, {key: 'scope-3'}, {key: 'compare'}]
        };
    },
    methods: {
        routeByTag(tag) {
            this.$router.push({
                name: tag.key,
                params: {site_id: _.get(this.$store.state, 'siteId')},
                query: {year: this.year}
                });
        }
    },
    watch: {
        '$store.state.route.name': function(newVal) {
            if (newVal === 'analysis') {
                this.$router.push({name: this.tags[0].key, query: {year: this.year}});
            }
        }
    },
    created() {
        /*
        if(this.gbId(this.$store.state.user.customerId) || !this.$store.state.user.permissions.canViewComparisons){
            this.tags= [{key: 'general-analysis'}, {key: 'scope-1'}, {key: 'scope-2'}, {key: 'scope-3'}]
        }
        */
        let tag = _.find(this.tags, {key: this.route.name});
        tag = tag ? tag : this.tags[0];
        this.$router.push({name: tag.key, query: {year: this.year}});
    }
};
</script>

<style lang="scss" scoped>
.borderless {
    th {
        border-top: none;
        font-size: 1.2em;
    }
}

.card-nav {
    cursor: pointer;
    &:hover {
        color: #1c7430;
    }
}
</style>

<i18n src="../../i18n/common.json"></i18n>
<i18n src="../../i18n/carbonEmissionTable.json"></i18n>

<i18n>
    {
        "tr": {
            "general-analysis": "Genel",
            "scope-1": "scope1",
            "scope-2": "scope2",
            "scope-3": "scope3",
            "compare": "Karşılaştırma"
    },
        "en": {
            "general-analysis": "General",
            "scope-1": "scope1",
            "scope-2": "scope2",
            "scope-3": "scope3",
            "compare": "Compare"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Analysis/AnalyzeMain.vue